export const FORT_POINT_TYPES = {
    SLOT: 'flag',
    COMMAND_CENTER: 'stronghold',
}

export const BATTLE_DIRECTIONS = {
    ATTACK: 'attack',
    DEFENSE: 'defense',
}



// WEBPACK FOOTER //
// ./containers/PostbattleScreen/components/FortBattleSeries/constants.js